var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main_menu_component" },
    [
      _c(
        "button",
        {
          staticClass: "md-button main_menu_button md-theme-default",
          attrs: { type: "button" },
          on: { click: _vm.toggleMenu }
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _vm.mainMenu
        ? _c("div", {
            staticClass: "main_menu_overlay",
            on: { click: _vm.toggleMenu }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.mainMenu
          ? _c(
              "div",
              { staticClass: "main_menu" },
              [
                _c("div", { staticClass: "md-toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "md-toolbar-section-end" },
                    [_c("get-country-domain", { attrs: { menu: true } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-toolbar-section-end" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "desktop-login-button main_menu_header_login",
                          attrs: { href: _vm.loginUrl }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("home.login")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "main_menu_close_button",
                          on: { click: _vm.toggleMenu }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("close")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "md-list",
                  _vm._l(_vm.items, function(item) {
                    return _c(
                      "md-list-item",
                      {
                        key: item.id,
                        staticClass: "main_menu_item",
                        attrs: { href: item.url }
                      },
                      [
                        item.icon
                          ? _c("span", { staticClass: "icon" }, [
                              _c("img", {
                                attrs: {
                                  src: "/imgs/icons/menu/icon-menu-" + item.icon
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "md-list-item-text" }, [
                          _vm._v(_vm._s(item.label))
                        ])
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "main_menu_social" },
                  _vm._l(_vm.social, function(item) {
                    return _c("div", { key: item.id }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: item.url[_vm.locale],
                            target: "_blank"
                          }
                        },
                        [_c("img", { attrs: { src: item.image } })]
                      )
                    ])
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md-ripple" }, [
      _c("div", { staticClass: "md-button-content" }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("menu")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-708c191e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708c191e","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MainMenuComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-708c191e","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MainMenuComponent.vue
// module chunks = 1 2 3